import React from 'react';
import { Button } from '@mui/material';

export default function CTAButton({
  children,
  href,
  onClick,
  fullWidth = true,
  size = 'large',
  sx = {},
  variant = 'gradient',
  ...rest
}) {
  const gradientStyles =
    variant === 'gradient'
      ? {
          background: 'linear-gradient(135deg, #ff6b6b 0%, #f06595 50%, #845ef7 100%)',
          color: '#fff',
          fontWeight: 700,
          letterSpacing: 0.3,
          boxShadow: '0 8px 20px rgba(240,101,149,0.35)',
          '&:hover': {
            background: 'linear-gradient(135deg, #f06595 0%, #845ef7 50%, #5c7cfa 100%)',
            boxShadow: '0 10px 24px rgba(92,124,250,0.45)',
          },
          '&:focus-visible': {
            outline: '2px solid #fff',
            outlineOffset: '2px',
          },
        }
      : {};

  return (
    <Button
      component={href ? 'a' : 'button'}
      href={href}
      onClick={onClick}
      fullWidth={fullWidth}
      size={size}
      variant="contained"
      sx={{
        minWidth: 220,
        maxWidth: fullWidth ? '100%' : undefined,
        justifyContent: 'center',
        ...gradientStyles,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}

